module.exports = __webpack_public_path__ + "img/commandesSuivi.7968d0cd.png";